<template>
  <div class="appointment-short-info">
    <h6 class="is-bold"> {{ title }} </h6>

    <div class="row">
      <div class="col-12">
        <i class="fa fa-clock-o is-bold" style="margin-right: 2px; margin-bottom: 0.7rem;"></i>
      <span class="is-bold"> {{ moment(appointment.start).format('DD MMMM YYYY [&nbsp;] HH:mm') }} &nbsp; - &nbsp; {{ moment(appointment.end).format('HH:mm') }}</span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-2">
        <span>{{$t('agenda.appointments.facility')}}:&nbsp;</span>
        <span class="is-bold">{{appointment.facility ? appointment.facility.name : 'N/A'}}</span>
      </div>

      <div class="col-12 mb-2">
        <span>{{ $t('evocall.appointment.type') }}</span>:&nbsp;
        <span class="is-bold" v-if="appointment.type">{{getFormatedAppointmentType()}}</span>
        <span class="is-bold" v-else>N/A</span>
      </div>

      <div class="col-12 mb-2">
        <span v-if="appointment.parent_id !== null">{{ $t('clinical.appointments.audiologist') }}:</span>
        <span v-else>{{ $t('clinical.appointments.dispenser') }}:</span>
        &nbsp;
        <span class="is-bold" v-if="appointment.user">
          <span>{{ appointment.user.name }}</span>
          <span v-if="appointment.user && appointment.user.nickname"> ({{ appointment.user.nickname }}) </span>
        </span>
        <span class="is-bold" v-else>N/A</span>
      </div>

      <div class="col-12 mb-2" v-on="appointment.has_companion_person ? {click: () => goToPersonFile()} : {}" :class="{ clickable: appointment.has_companion_person }">
        <span>{{ $t('evocall.appointment.companion') }}:</span>&nbsp;
        <span class="is-bold" v-if="appointment.companion || appointment.companion_person">
          {{ appointment.companion_person ? appointment.companion_person.name : appointment.companion }}
          <span v-if="selectedRelationshipType">
            ({{ $t(`${selectedRelationshipType.name}`) }})
          </span>
        </span>
        <span class="is-bold" v-else-if="selectedRelationshipType">
          {{ $t(selectedRelationshipType.name) }}
        </span>
        <span class="is-bold" v-else>N/A</span>
        &nbsp;
        <i v-if="appointment.has_companion_person" class="fa fa-external-link" aria-hidden="true"> </i>
      </div>

      <div class="col-12 mb-2">
        <span>{{ $t('clinical.appointments.marketing_code') }}</span>:&nbsp;
        <span class="is-bold">{{appointment.marketing_code || 'N/A' }}</span>
      </div>

      <div class="col-12 mb-2">
        <span>{{ $t('clinical.appointments.outcome') }}:&nbsp;</span>
        <span class="is-bold" v-if="appointment.status">
          {{ `${$t(`clinical.people.anamnesis.outcome_translations.${(appointment.status.name).toLowerCase()}`)}`}}
          <span v-if="appointment.status_reason">
            ({{ `${$t(`clinical.people.anamnesis.outcome_translations.${(appointment.status_reason.name).toLowerCase()}`)}`}})
          </span>
        </span>
        <span class="is-bold" v-else>N/A</span>
      </div>
    </div>
  </div>
</template>
<script>
import { RELATIONSHIP_TYPES } from './config'
export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
    appointment: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('evocall.appointment.info')
      }
    }
  },
  data () {
    return {
      relationshipTypesOptions: RELATIONSHIP_TYPES
    }
  },
  methods: {
    goToPersonFile: function () {
      setTimeout(() => {
        this.$router.push({ path: `/${this.serviceSlug}/clinical/people/${this.appointment.companion_person.id}` })
      }, 500)
      this.$emit('closeAppointmentDetailsModal')
    },
    getFormatedAppointmentType: function () {
      if (this.appointment && this.appointment.type) {
        let label = this.appointment.type.name
        if (this.appointment.type.slug && this.appointment.type.name !== this.appointment.type.slug) {
          label += ` (${this.appointment.type.slug})`
        }
        return label
      }
      return ''
    }
  },
  computed: {
    selectedRelationshipType: function () {
      if (!this.appointment || !this.appointment.relationship_type_id) {
        return null
      }

      return this.relationshipTypesOptions.find(relation => relation.id === this.appointment.relationship_type_id)
    },
  }
}
</script>
